// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.equipmentTableWrapper__tfwNw {
  width: 100%;
  max-width: 100%;
  overflow: auto;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--basic-box-shadow);
}
.equipmentTableWrapper__tfwNw::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.equipmentTableWrapper__tfwNw::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.equipmentTableWrapper__tfwNw::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.equipmentTableWrapper__tfwNw::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.equipmentTable__NNHRi {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  position: relative;
}
.equipmentTable__NNHRi th {
  color: var(--tables-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  padding: 16px 25px;
  text-align: left;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  text-wrap: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}
.equipmentTable__NNHRi td {
  color: var(--tables-primary-row-text-main);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  padding: 16px 25px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  white-space: normal;
}
@media (max-width: 1024px) {
  .equipmentTable__NNHRi th {
    padding: 16px 12px;
  }
  .equipmentTable__NNHRi td {
    padding: 16px 12px;
  }
}
@media (max-width: 900px) {
  .equipmentTable__NNHRi th {
    padding: 8px 6px;
  }
  .equipmentTable__NNHRi td {
    padding: 8px 6px;
  }
}

.equipmentTableBodyRow__yiIE_:hover {
  background: var(--tables-primary-row-surface-hover);
}

.equipmentTableSortIcon__KPV1p {
  margin-left: 5px;
  cursor: pointer;
  outline: none;
}
.equipmentTableSortIcon__KPV1p path {
  fill: var(--tables-title-icon);
}

.activeSort___ReCi path {
  fill: var(--tables-primary-row-icon);
}

.facilityName__WjggB {
  color: var(--tables-primary-row-text-additional);
}

.equipmentAddedMessage__eo8Hy {
  font-size: 11px;
  color: var(--tables-primary-row-text-additional);
  margin-top: 10px;
}

.ellipsisTextOneLine__eQuek {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
}

.ellipsisTextThreeLines__JTaZ0 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
}

.skeletonRow__qq7Uz td:first-child .skeletonText__lQJD3 {
  display: none;
}

.skeletonText__lQJD3 {
  height: 32px;
}

.deleteIconWrapper__QkStx {
  display: flex;
  align-items: center;
  justify-content: center;
}

.deleteIcon__KKe9N {
  cursor: pointer;
}
.deleteIcon__KKe9N rect {
  fill: transparent;
}
.deleteIcon__KKe9N path {
  stroke: var(--buttons-surface);
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageTemplate/components/TableEquipments/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,eAAA;EACA,cAAA;EACA,qDAAA;EACA,mCAAA;AAzEF;AAoBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,+BAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,8BAAA;EACA,kBAAA;AApBJ;AAuBE;EACE,gBAAA;EACA,kBAAA;AArBJ;;AA6DA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AA1DF;AA4DE;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AA1DJ;AA6DE;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yDAAA;EACA,mBAAA;AA3DJ;AA8DE;EACE;IACE,kBAAA;EA5DJ;EA+DE;IACE,kBAAA;EA7DJ;AACF;AAgEE;EACE;IACE,gBAAA;EA9DJ;EAiEE;IACE,gBAAA;EA/DJ;AACF;;AAoEE;EACE,mDAAA;AAjEJ;;AAqEA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;AAlEF;AAoEE;EACE,8BAAA;AAlEJ;;AAuEE;EACE,oCAAA;AApEJ;;AAwEA;EACE,gDAAA;AArEF;;AAwEA;EACE,eAAA;EACA,gDAAA;EACA,gBAAA;AArEF;;AAwEA;EA1HE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAuHA,qBAAA;EACA,aAAA;AAhEF;;AAmEA;EAhIE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EA6HA,qBAAA;EACA,aAAA;AA3DF;;AAgEI;EACE,aAAA;AA7DN;;AAkEA;EACE,YAAA;AA/DF;;AAkEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AA/DF;;AAkEA;EACE,eAAA;AA/DF;AAgEE;EACE,iBAAA;AA9DJ;AAgEE;EACE,8BAAA;AA9DJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.equipmentTableWrapper {\n  width: 100%;\n  max-width: 100%;\n  overflow: auto;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--basic-box-shadow);\n\n  @include scrollBar;\n}\n\n.equipmentTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  position: relative;\n\n  th {\n    color: var(--tables-title-text);\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n    text-transform: uppercase;\n    padding: 16px 25px;\n    text-align: left;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n    text-wrap: nowrap;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n  }\n\n  td {\n    color: var(--tables-primary-row-text-main);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n    padding: 16px 25px;\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    white-space: normal;\n  }\n\n  @media (max-width: 1024px) {\n    th {\n      padding: 16px 12px;\n    }\n\n    td {\n      padding: 16px 12px;\n    }\n  }\n\n  @media (max-width: 900px) {\n    th {\n      padding: 8px 6px;\n    }\n\n    td {\n      padding: 8px 6px;\n    }\n  }\n}\n\n.equipmentTableBodyRow {\n  &:hover {\n    background: var(--tables-primary-row-surface-hover);\n  }\n}\n\n.equipmentTableSortIcon {\n  margin-left: 5px;\n  cursor: pointer;\n  outline: none;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.activeSort {\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n\n.facilityName {\n  color: var(--tables-primary-row-text-additional);\n}\n\n.equipmentAddedMessage {\n  font-size: 11px;\n  color: var(--tables-primary-row-text-additional);\n  margin-top: 10px;\n}\n\n.ellipsisTextOneLine {\n  @include ellipsis-text;\n  -webkit-line-clamp: 1;\n  line-clamp: 1;\n}\n\n.ellipsisTextThreeLines {\n  @include ellipsis-text;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n}\n\n.skeletonRow {\n  td {\n    &:first-child .skeletonText {\n      display: none;\n    }\n  }\n}\n\n.skeletonText {\n  height: 32px;\n}\n\n.deleteIconWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.deleteIcon {\n  cursor: pointer;\n  rect {\n    fill: transparent;\n  }\n  path {\n    stroke: var(--buttons-surface);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"equipmentTableWrapper": `equipmentTableWrapper__tfwNw`,
	"equipmentTable": `equipmentTable__NNHRi`,
	"equipmentTableBodyRow": `equipmentTableBodyRow__yiIE_`,
	"equipmentTableSortIcon": `equipmentTableSortIcon__KPV1p`,
	"activeSort": `activeSort___ReCi`,
	"facilityName": `facilityName__WjggB`,
	"equipmentAddedMessage": `equipmentAddedMessage__eo8Hy`,
	"ellipsisTextOneLine": `ellipsisTextOneLine__eQuek`,
	"ellipsisTextThreeLines": `ellipsisTextThreeLines__JTaZ0`,
	"skeletonRow": `skeletonRow__qq7Uz`,
	"skeletonText": `skeletonText__lQJD3`,
	"deleteIconWrapper": `deleteIconWrapper__QkStx`,
	"deleteIcon": `deleteIcon__KKe9N`
};
module.exports = ___CSS_LOADER_EXPORT___;
